import { render } from "./GerenciamentoComissoes.vue?vue&type=template&id=3ea5c8ac&scoped=true"
import script from "./GerenciamentoComissoes.vue?vue&type=script&lang=js"
export * from "./GerenciamentoComissoes.vue?vue&type=script&lang=js"

import "./GerenciamentoComissoes.vue?vue&type=style&index=0&id=3ea5c8ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea5c8ac"]])

export default __exports__